import type { IObjectiveTypeBaseReason } from './ObjectiveTypeBaseReason.interface';

export default class ObjectiveTypeBaseReason implements IObjectiveTypeBaseReason {
  avoidingRiskOfIncreasingVariableInterestRate: boolean;
  makeBudgetingEasier: boolean;
  advantageOfPotentialFuture: boolean;
  flexibilityWithRespectToRepayment: boolean;
  limitingRisk: boolean;
  retainingDegree: boolean;
  easierBudgeting: boolean;
  minimiseInterestPaid: boolean;
  higherLendingLimit: boolean;
  lowerDepositRequired: boolean;
  buildUpEquity: boolean;
  accommodateTemporaryReduction: boolean;
  accommodateAnticipated: boolean;
  variableAndUnpredictableIncome: boolean;
  recommendationProvidedBy: boolean;
  taxationOrAccountingReasons: boolean;
  assistsWithInvestmentPurchases: boolean;
  anticipatedVariableCashFlows: boolean;
  allowsAccessToFundsAtAnyTime: boolean;
  flexibilityToManageRepayments: boolean;
  noNeedToApply: boolean;
  ongoingNeedForFunds: boolean;
  allowsPayingOffLoanSooner: boolean;
  allowsAccessToFunds: boolean;
  accessPrepaidFunds: boolean;
  other: boolean;
  otherComments: string;
  additionalComments: string;

  static build = (data: IObjectiveTypeBaseReason) => new ObjectiveTypeBaseReason(data);
  static blank = () => new ObjectiveTypeBaseReason();

  /**
   * Constructor
   * @param {IObjectiveTypeBaseReason} data
   */
  constructor(data?: IObjectiveTypeBaseReason) {
    this.avoidingRiskOfIncreasingVariableInterestRate =
      data?.avoidingRiskOfIncreasingVariableInterestRate === true;
    this.makeBudgetingEasier = data?.makeBudgetingEasier === true;
    this.advantageOfPotentialFuture = data?.advantageOfPotentialFuture === true;
    this.flexibilityWithRespectToRepayment = data?.flexibilityWithRespectToRepayment === true;
    this.limitingRisk = data?.limitingRisk === true;
    this.retainingDegree = data?.retainingDegree === true;
    this.easierBudgeting = data?.easierBudgeting === true;
    this.minimiseInterestPaid = data?.minimiseInterestPaid === true;
    this.higherLendingLimit = data?.higherLendingLimit === true;
    this.lowerDepositRequired = data?.lowerDepositRequired === true;
    this.buildUpEquity = data?.buildUpEquity === true;
    this.accommodateTemporaryReduction = data?.accommodateTemporaryReduction === true;
    this.accommodateAnticipated = data?.accommodateAnticipated === true;
    this.variableAndUnpredictableIncome = data?.variableAndUnpredictableIncome === true;
    this.recommendationProvidedBy = data?.recommendationProvidedBy === true;
    this.taxationOrAccountingReasons = data?.taxationOrAccountingReasons === true;
    this.taxPurposes = data?.taxPurposes === true;
    this.discountsOnInterestRate = data?.discountsOnInterestRate === true;
    this.assistWithCashFlow = data?.assistWithCashFlow === true;
    this.assistsWithInvestmentPurchases = data?.assistsWithInvestmentPurchases === true;
    this.anticipatedVariableCashFlows = data?.anticipatedVariableCashFlows === true;
    this.allowsAccessToFundsAtAnyTime = data?.allowsAccessToFundsAtAnyTime === true;
    this.flexibilityToManageRepayments = data?.flexibilityToManageRepayments === true;
    this.noNeedToApply = data?.noNeedToApply === true;
    this.ongoingNeedForFunds = data?.ongoingNeedForFunds === true;
    this.allowsPayingOffLoanSooner = data?.allowsPayingOffLoanSooner === true;
    this.allowsAccessToFunds = data?.allowsAccessToFunds === true;
    this.accessPrepaidFunds = data?.accessPrepaidFunds === true;
    this.other = data?.other === true;
    this.otherComments = data?.otherComments || '';
    this.additionalComments = data?.additionalComments || '';
  }
}
